import { PsOriginBase } from './PsOriginBase';

export class PsDocument extends PsOriginBase {

    _id; // number
    _name; // string
    _stateColor; // string | undefined

    constructor(
        id,
        name,
        stateColor,
    ) {
        super();
        this._id = id;
        this._name = name;
        this._stateColor = `#${stateColor}`;
    }

    static fromAPIDocument(document) {
        return new this(
            document.id,
            document.name || '',
            document.state ? document.state.color : undefined,
        );
    }

    id() {
        return this._id;
    }

    name() {
        return this._name;
    }

    stateColor() {
        return this._stateColor;
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/model/PsDocument.js